import React, { Fragment } from 'react';
import ScheduleHeader      from './ScheduleHeader';
import ScheduleItem        from './ScheduleItem';
import './Schedule.css';

const Schedule = (props) => {
    let {
        source: {
            name = '',
            count = '',
            date = '',
            program
        },
        isCurrentSlide
    } = props;

    return (
        <div className={ `b-slide ${ isCurrentSlide ? 'b-slide--active' : '' }` }>
            <ScheduleHeader
                name={ name }
                count={ count }
                date={ date }
            />
            { program.map((speaker, index) => (
                <ScheduleItem speaker={ speaker } key={ index }/>)
            ) }
        </div>
    );
};

export default Schedule;
